import "./module_category_filter";
import { initialiseModuleCategoryMultiselect } from "./module_category";

initialiseModuleCategoryMultiselect();
